// The Site Builder is served by the standalone site-webapp (nginx routes
// /site/* on the org subdomains to its dev server on :3003). flex2-webapp does
// not mount any Site Builder UI; this catch-all converts any SPA navigation into
// /site/* — the sidebar menu item, a deep link, a pasted URL — into a full page
// load so the browser actually leaves this bundle and fetches site-webapp's
// index.
//
// The handoff keeps the session because /site is a path prefix on the SAME org
// subdomain: localStorage is per-origin, so the auth token site-webapp reads is
// the one this app wrote. A separate hostname would land the user logged out.
//
// Loop guard: on hosts whose nginx does NOT route /site to site-webapp (e.g.
// personal dev instances), the reload lands right back here — detect the
// immediate re-entry and show a note instead of reloading forever.
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const LAST_HANDOFF_KEY = "siteHandoffAt";

export default function SiteHandoff() {
  const { pathname, search } = useLocation();
  const [looping, setLooping] = useState(false);

  useEffect(() => {
    const last = Number(sessionStorage.getItem(LAST_HANDOFF_KEY) || 0);
    if (Date.now() - last < 5000) {
      setLooping(true);
      return;
    }
    sessionStorage.setItem(LAST_HANDOFF_KEY, String(Date.now()));
    window.location.replace(pathname + search);
  }, [pathname, search]);

  if (!looping) return null;
  return (
    <div style={{ padding: 40, fontFamily: "sans-serif" }}>
      The Site Builder is served by site-webapp, but this host&apos;s nginx
      isn&apos;t routing <code>/site</code> to it — see
      /etc/nginx/sites-available/liftconnectpro.dev for the reference block.
    </div>
  );
}
